<template>
    <div class="zoneEchantillons" v-if="samples.length >= 2">
        <h2>Choisissez 2 échantillons</h2>
        <div id="containerCarousel">
            <carousel id="carouselSamples"
                      :perPageCustom="[[0, 1], [600, 2], [800, 3], [1200, 4]]"
                      :paginationEnabled="false"
                      :navigationEnabled="true"
                      navigationPrevLabel="<img width='20px' src='bundles/site/img/arrowLeft.svg' class='svg'>"
                      navigationNextLabel="<img width='20px' src='bundles/site/img/arrowRight.svg' class='svg'>"
            >
                <slide v-for="sample in samples" :key="sample.id">
                    <div class="custom-control custom-checkbox">
                        <input @change="onChange($event, sample.id)"
                               v-model="checkedSamples" type="checkbox"
                               :value="sample.id"
                               :id="'input-' + sample.id"
                               class="custom-control-input"
                        />
                        <label class="custom-control-label" :for="'input-' + sample.id" :name="'input-' + sample.id">
                            <img class="lazyload" :data-src="sample.image.path" :alt="sample.title">
                            <span>{{sample.title}}</span>
                        </label>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>

    import { mapActions, mapState, mapGetters } from 'vuex';
    import { Carousel, Slide } from 'vue-carousel';

    import store from '../store';

    const CartSamples = {
        name: 'ponroy-cart-samples',
        store,
        components: {
            Carousel,
            Slide
        },
        data() {
            return {
                checkedSamples: [],
                hasError: false,
                owl: null,
            }
        },
        props: {
        },
        methods: {
            ...mapActions('cart', [
                'getSamples',
                'addToCart',
                'removeCartItem',
            ]),
            isChecked(data) {
                for (let id in this.sampleItems) {
                    if(this.sampleItems[id]['orderableId'] === data) {
                        return true;
                    }
                }

                return false;
            },
            onChange(event, data) {

                let canAdd = this.checkedSamples.length <= 2;

                if (event.target.checked && canAdd) {
                    let orderable = { repository: 'site.repository.gift', id : data };
                    let quantity = 1;
                    this.addToCart({orderable, quantity});
                } else {
                    let item = this.sampleItems.filter(item => item.orderableId === data);
                    if (item.length > 0) {
                        this.removeCartItem({id : item[0].id});
                    }
                }
            }
        },
        computed: {
            ...mapGetters('cart', [
                'samples',
                'sampleItems'
            ]),

        },
        watch: {
            samples(data) {
                for (let id in data) {
                    if (this.isChecked(data[id].id)) {
                        this.checkedSamples.push(data[id].id);
                    }
                }
            },
            sampleItems(data) {
                this.checkedSamples = data.map(item => item.orderableId);
            },
            checkedSamples(current, prev) {

                if (current.length > 2) {
                    this.checkedSamples = prev;
                }

                if (current.length < 2) {
                    this.hasError = true;
                }

                if (current.length === 2) {
                    this.hasError = false;
                }

            }
        },
        created() {
            this.getSamples();

        },
    };

    export default CartSamples;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartSamples.vue